module.exports = __webpack_public_path__ + "static/media/08.64b9ae04.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/08.jpg
// module id = 570
// module chunks = 0